import { formatFormFieldReport } from '../ProblemsReporter.js';

export const execute = (node, context) => {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  const {
    appearance
  } = node;

  if (appearance && (
    appearance.prefixAdorner !== undefined ||
    appearance.suffixAdorner !== undefined
  )) {
    const errorMessage = `Prefixes and suffixes are not supported by ${executionPlatformLabel}`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  return true;
};
